import { fromEvent, ReplaySubject, Subject, Subscription } from "rxjs";
import { DOMHelper } from "src/app/common/DOMHelper";

export class DragManager{


	constructor()
	{
		
	}
	
	dragDOM(dom:HTMLElement, event:MouseEvent):Promise<any>
	{
		// this.dragStart(event);
		return Promise.resolve(1);
	}
	getTouchPosition(event:any):Object
	{
		// 當 touch end 時，是不會傳回 touches
		if (event.touches === undefined && event.pageX !== undefined){
			return { x: event.pageX, y: event.pageY };
		}
		var touch:Touch = event.touches.length>0 ? event.touches[0] : event.changedTouches[0];
		return {
			x:touch.pageX,
			y:touch.pageY,
			clientX:event.clientX,
			clientY:event.clientY
		};
	}
	private getMousePosition(event:MouseEvent):any
	{
		return {
			x:event.pageX,
			y:event.pageY,
			clientX:event.clientX,
			clientY:event.clientY
		}
	}
	private getPointerPosition(event:PointerEvent):any
	{
		return {
			x:event.pageX,
			y:event.pageY,
			clientX:event.clientX,
			clientY:event.clientY
		};
	}


	pointerStart(event:PointerEvent, touch:HTMLElement = null):Subject<any>
	{
		let is_eye_tracking_drag = false;
		if(event.pointerType === 'eye-tracker') {
			is_eye_tracking_drag = true;
		}

		var subject:Subject<any> = new ReplaySubject(1);
		
		var sub:Subscription = new Subscription(()=>{
			is_eye_tracking_drag = false;
		});
		var point:any = this.getPointerPosition(event);
		subject.next({type:"start", event:event, point:point, target:touch});
		
		sub.add(
			fromEvent(document, "pointerdown").subscribe((e: PointerEvent) => {
				if (is_eye_tracking_drag && e.pointerType !== 'eye-tracker') {
					return;
				}
				if (!is_eye_tracking_drag && e.pointerType === 'eye-tracker') {
					return;
				}
				console.log('drag manager pointerdown', e);
				if (event.pointerId !== undefined && e.pointerId !== event.pointerId) {
					subject.next({type:"cancel", event:e, multiTouch: true, target:touch});
					sub.unsubscribe();
				}

				if(is_eye_tracking_drag && e.pointerType === 'eye-tracker') {
					subject.next({type:"end", point:this.getPointerPosition(e), event:e, target:touch});
					sub.unsubscribe();
				}
			})
		);
		
		sub.add(
			fromEvent(touch ? touch : window, "pointermove").subscribe((e:PointerEvent)=>{
				if (is_eye_tracking_drag && e.pointerType !== 'eye-tracker') {
					return;
				}
				if (!is_eye_tracking_drag && e.pointerType === 'eye-tracker') {
					return;
				}
				if (event.pointerId !== undefined && e.pointerId !== event.pointerId) {
					subject.next({type:"cancel", event:e, multiTouch: true, target:touch});
					sub.unsubscribe();
				}
				subject.next({
					type: "move", 
					point: this.getPointerPosition(e), 
					event: e,
					target:touch
				});
			})
		);
		
		sub.add(
			fromEvent(window, "pointerup").subscribe((e:PointerEvent)=>{
				subject.next({type:"end", point:this.getPointerPosition(e), event:e, target:touch});
				sub.unsubscribe();
			})
		);
		
		sub.add(
			fromEvent(window, "pointercancel").subscribe((e: PointerEvent)=>{
				subject.next({type:"cancel", event:e, target:touch});
				sub.unsubscribe();
			})
		);
		
		return subject;
	}
	
	touchStart(event:TouchEvent, touch:HTMLElement = null):Subject<any>
	{
		

		var sub:Subscription = new Subscription(()=>{});
		var subject:Subject<any> = new ReplaySubject(1);
		var point:any = this.getTouchPosition(event);
		subject.next({type:"start", event:event, point:point});
		/*
		touchcancel
		touchend
		touchmove
		touchstart
		*/
		sub.add(
			fromEvent(touch ? touch : window, "touchmove").subscribe((event:TouchEvent)=>{
				// subject.next({type:"move", event:event});
				subject.next({type:"move", point:this.getTouchPosition(event), event:event});
			})
		);
		sub.add(
			fromEvent(window, "touchend").subscribe((event:TouchEvent)=>{
				subject.next({type:"end", point:this.getTouchPosition(event), event:event});
				sub.unsubscribe();
			})
		);
		sub.add(
			fromEvent(window, "touchcancel").subscribe((event)=>{
				subject.next({type:"cancel", event:event});
				sub.unsubscribe();
			})
		);
		return subject;
	}
	
	dragStart(event:MouseEvent):Subject<any>
	{
		event.stopImmediatePropagation();
		// var subject:Subject<any> = new Subject();
		var sub:Subscription = new Subscription(()=>{});
		var subject:Subject<any> = new ReplaySubject(1);
		subject.next({type:"start", point:this.getMousePosition(event)});
		sub.add(
			fromEvent(window, "mousemove").subscribe((event:MouseEvent)=>{
				subject.next({type:"move", target:event.target, point:this.getMousePosition(event)});
			})
		);
		sub.add(
			fromEvent(window, "mouseup").subscribe((event:MouseEvent)=>{
				subject.next({type:"end", target:event.target, point:this.getMousePosition(event)});
				sub.unsubscribe();
			})
		);
		return subject;
	}


	monitorMovement(target:HTMLElement, event:any, movementCallback):void
	{
		var subject:Subject<any>;
		if(event.type.indexOf("pointer")==0)
			subject = this.pointerStart(event, null);
		else if(event.type.indexOf("touch")==0)
			subject = this.touchStart(event, null);
		else if(event.type.indexOf("mouse")==0)
			subject = this.dragStart(event);
		else
			return;
		
		let gRect:DOMRect = target.getBoundingClientRect() as DOMRect;
		var subscription:Subscription = subject.subscribe((o:any)=>{
			if(o.type == "start") {
				gRect.x -= o.point.x;
				gRect.y -= o.point.y;
			}

			movementCallback(o.type, DOMHelper.getLocalPoint(target, {x:gRect.x+o.point.x, y:gRect.y+o.point.y}));

			if(o.type == "end" || o.type == "cancel" || o.type == "timeout") {
				subscription.unsubscribe();
			}
		});
	}
}